import React from 'react';

export function StepEditLabel() {
  return (
    <>
      Cílové průmyslové místo - <b>Editace údajů</b>
    </>
  );
}
